<mat-select #select [attr.aria-labelledby]="_formField.getLabelId()" (focusin)="onFocusIn($event)" (focusout)="onFocusOut($event)" [value]="_value" (valueChange)="value = $event" [disabled]="_disabled" [placeholder]="_placeholder">
    <mat-option *ngFor="let option of options" [value]="option.value">{{ option.label }}</mat-option>
</mat-select>
